import { forwardRef } from 'react'
import classNames from 'classnames'
import { useTabsContext } from './context'
import type { CommonProps } from '../@types/common'
import type { ReactNode } from 'react'

export interface TabListProps extends CommonProps {
    children?: ReactNode
    variant?: 'underline' | 'pill'
}

const TabList = forwardRef<HTMLDivElement, TabListProps>((props, ref) => {
    const { className, children, variant, ...rest } = props

    const { variant: contextVariant } = useTabsContext()

    const variantValue = variant || contextVariant

    const tabListClass = classNames(
        'tab-list',
        `tab-list-${variantValue}`,
        className
    )

    return (
        <div ref={ref} className={tabListClass} {...rest}>
            {children}
        </div>
    )
})

TabList.displayName = 'TabList'

export default TabList 